export const enrollModel = {
  enrollmentSource: null,
  drugPatient: null,
  enrollmentDataSource: null,
  firstName: null,
  lastName: null,
  address1: null,
  address2: null,
  city: null,
  state: null,
  zip: null,
  dob: null,
  email: null,
  mobilePhoneNumber: null,
  gender: null,

  pharmacyInsurance: {
    coverageType: null,
    planType: null,
    source: null,
    pbmName: null,
    memberId: null,
    bin: null,
    pcn: null,
    group: null,
  },

  prescriber: {
    type: null,
    firstName: null,
    lastName: null,
    npi: null,
    practiceName: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip: null,
  },

  drugAnswers: {
    hasMedicare: null,
    hasMedicaid: null,
    isGovermentPaid: null,
    isAge18: null,
    hasMedicalAcknowledge: null,
    isAgree: null,
    hasAnyOtherGovermentInsurance: null,
    termAndCondAccepted: null,
    hasPermissionOptIn: null,
    hasMarketingOptIn: null,
  },
};

export const replaceModel = {
  mobilePhoneNumber: null,
  dob: null,
};
